import React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';

export const QuoteShow = () => (
  <Show title="Quote details">
    <SimpleShowLayout>
      <TextField source="quote_text" label="Quote Text" />
      <TextField source="author_name" label="Author" />
    </SimpleShowLayout>
  </Show>
);

